module.exports = __webpack_public_path__ + "img/Sbai.1bc6ffc3.svg";